import * as React from 'react';
export const IcElephant = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17 3h-4a4 4 0 00-4 4c.001.338.048.675.14 1 .058.235.142.463.25.68.044.111.098.218.16.32a3 3 0 00.29.44c.06.07.11.15.18.22.183.207.383.398.6.57a1.002 1.002 0 01.21 1.4.999.999 0 01-1.4.2A6 6 0 017.09 8H6a3 3 0 00-3 3v9a1 1 0 001 1h2a1 1 0 001-1v-2h4v2a1 1 0 001 1h2a1 1 0 001-1v-7a1 1 0 012 0v3a2 2 0 004 0V7a4 4 0 00-4-4zm-1 5a1 1 0 110-2 1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
